import React from 'react';
import { Divider, Grid, Box, Avatar } from '@mui/material';

interface BannerProps {
  icon?: any;
  action?: any;
  children: any;
}

export function Banner({ icon, action, children }: BannerProps) {
  return (
    <>
      <Box sx={{px: 2, py: 2}}>
        <Grid container sx={{alignItems: 'center'}}>
          {icon && (
            <Grid size={{ xs: 1 }}>
              <Avatar sx={{ backgroundColor: (theme) => theme.palette.primary.main }}>{icon}</Avatar>
            </Grid>
          )}
          <Grid>{children}</Grid>
          {action && <Grid size={{ xs: 2 }}>{action}</Grid>}
        </Grid>
      </Box>
      <Divider sx={{ marginBottom: (theme) => theme.spacing(2) }} />
    </>
  );
}
